<template>
  <span class="app-badge" :class="badgeClasses" :style="badgeStyle">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
import { VARIANT_COLORS } from './variants.js'

export default {
  name: 'AppBadge',
  props: {
    variant: { type: String, default: 'secondary' },
    pill: { type: Boolean, default: false },
    label: { type: String, default: '' },
    tag: { type: String, default: 'span' }
  },
  computed: {
    badgeClasses() {
      return {
        'app-badge--pill': this.pill
      }
    },
    badgeStyle() {
      const c = VARIANT_COLORS[this.variant] || VARIANT_COLORS.secondary
      return {
        backgroundColor: c.bg,
        color: c.text,
        borderColor: c.border
      }
    }
  }
}
</script>

<style scoped>
.app-badge {
  display: inline-block;
  padding: 0.25em 0.65em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  border: 1px solid transparent;
}
.app-badge--pill { border-radius: 50rem; }
</style>
